import React, { useCallback } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { debounce } from './debounce';

const CommonSearchField = ({
  onChange,
  placeholder,
}: {
  onChange?: (value: string) => void;
  placeholder?: string;
}) => {
  const handleSearch = useCallback(
    debounce((value: string) => {
      onChange?.(value);
    }, 500),
    []
  );
  return (
    <InputGroup onChange={(e: any) => handleSearch(e.target.value)}>
      <Form.Control
        placeholder={placeholder || 'Search here..'}
        aria-label='Username'
        aria-describedby='basic-addon1'
      />
    </InputGroup>
  );
};

export default CommonSearchField;
